import { createFileRoute } from '@tanstack/react-router';
import { AuditLogPage } from '@/features/settings/audit-page';

export const Route = createFileRoute('/w/$workspaceId/settings/audit')({ component: AuditLogPage });
